import { useContext } from 'react';
import { useParams } from 'react-router-dom';
import ModuleContext from '../pages/material/_contexts/ModuleContext';
import { useRoutes } from './useRoutes';

export function useMaterialLinkBuilder() {
  const { subjectSlug, methodSlug, nodeId: currentNodeId } = useParams();
  const { module, selectedModule } = useContext(ModuleContext);
  const { buildAbsolutePath } = useRoutes();

  /**
   * Builds the absolute path for the main material page using current route parameters.
   * @returns The material link or null if required parameters are missing
   */
  function buildMaterialLink() {
    if (!subjectSlug || !methodSlug || !module) return null;
    return buildAbsolutePath(['MATERIAL'], {
      subjectSlug: subjectSlug,
      methodSlug: methodSlug,
      moduleSlug: module.slug,
    });
  }

  /**
   * Builds the absolute path for a material TOC page, optionally with a specific node ID.
   * @param nodeId - Optional node ID to navigate to, defaults to current route's nodeId
   * @param _selectedModuleSlug - Optional submodule slug, defaults to current selected module, then super module slug
   * @returns The material TOC link or null if required parameters are missing
   */
  function buildMaterialTocLink(nodeId?: string, _selectedModuleSlug?: string) {
    const selectedModuleSlug = selectedModule?.slug || _selectedModuleSlug || '';
    if (!subjectSlug || !methodSlug || !module || !selectedModuleSlug) return null;

    return buildAbsolutePath(['MATERIAL', 'MATERIAL.CONTENT', 'MATERIAL.CONTENT.TOC'], {
      subjectSlug,
      methodSlug,
      moduleSlug: module.slug,
      selectedModuleSlug: selectedModuleSlug,
      nodeId: nodeId || currentNodeId || '',
    });
  }

  return {
    buildMaterialLink,
    buildMaterialTocLink,
  };
}
